import { render } from "./AttachmentsData.vue?vue&type=template&id=50b449d6"
import script from "./AttachmentsData.vue?vue&type=script&lang=js"
export * from "./AttachmentsData.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__